/**
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-03-30 15:23:09
 * @LastEditors: Ali2vu
 * @LastEditTime: 2021-02-02 14:52:20
 */
import passport from './passport'
import common from './common'
import statistics from './statistics'
import menu from './menu'
import permissions from './permissions'
import roles from './roles'
import user from './user'
import setting from './setting'
import carousel from './carousel'
import adPosition from './ad_position'
import link from './link'
import category from './category'
import article from './article'
import live from './live'
import lecturer from './lecturer'
import attachment from './attachment'
import sysLog from './sys_log'
import company from './company'
import openapi from './openapi'
import openapiServer from './openapi_server'
import adminTrade from './admin_trade'
import ws from './ws'
import settlement from './settlement'
import customer from './customer'
import bill from './bill'
import oss from './oss'
import home from './home'
import mx from './mx'
import contract from './contract'
import task from './task'
import adminTask from './admin_task'
import adminContract from './admin_contract'
import adminBill from './admin_bill'
import exportPdf from './exportPdf'
import announce from './announce'
import mission from './mission'
import invoice from './invoice'
import adminInvoice from './admin_invoice'
import invoicePartner from './invoice_partner'
import individual from './individual'
import invoiceOpen from "@/api/invoiceOpen"
import daily from './daily'
import job from './job'
import declare from "@/api/declare"
export default {
  // 通行证
  ...passport,
  // 通用
  ...common,
  // 统计数据
  ...statistics,
  // 菜单
  ...menu,
  // 权限
  ...permissions,
  // 角色
  ...roles,
  // 用户
  ...user,
  // 基础配置
  ...setting,
  // 轮播图
  ...carousel,
  // 广告位
  ...adPosition,
  // 友情链接
  ...link,
  // 分类管理
  ...category,
  // 文章管理
  ...article,
  // 直播管理
  ...live,
  // 讲师管理
  ...lecturer,
  // 附件管理
  ...attachment,
  // 系统日志管理
  ...sysLog,
  // 公司管理
  ...company,
  // 开放平台管理
  ...openapi,
  // 接口配置管理
  ...openapiServer,
  // 交易流水
  ...adminTrade,
  // 网商相关接口
  ...ws,
  // 银行中心->账户资料
  ...settlement,
  // 银行中心->人才签约
  ...customer,
  // 银行中心->结算清单
  ...bill,
  //上传oss
  ...oss,
  //首页
  ...home,
  ...mx,
  //账户
  ...contract,
  ...task,
  ...adminTask,
  ...adminContract,
  ...adminBill,
  ...exportPdf,//获取协议双方
  ...announce,//公告管理
  ...mission,//生成邀请二维码
  ...invoice,//在线开票
  ...adminInvoice,//开票审核
  ...invoicePartner,//开票管理
  ...individual,//个体户注册
  ...invoiceOpen,//发票代开
  ...daily, // 日结
  ...job, //公域任务结算
  ...declare,//申报中心
}
